"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const container = theme => ({
    position: 'fixed',
    alignItems: 'center',
    height: constants_1.navbarStyle.height,
    width: constants_1.navbarStyle.width,
    backgroundColor: theme === 'light' ? '#BA352C' : '#20222D',
    zIndex: constants_1.fixedZIndex.navbar,
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 15,
    paddingRight: 15,
    color: 'white'
});
const left = {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: 10,
    alignItems: 'center'
};
const right = {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
    columnGap: 10,
    alignItems: 'center'
};
const userInfo = {
    display: 'grid',
    gridTemplateRows: 'auto auto',
    rowGap: 5
};
const image = {
    height: 35,
    width: 35
};
const logoutIcon = {
    height: 20,
    width: 20
};
const font = {
    color: 'white'
};
const containerDefaultProfile = {
    backgroundColor: '#EDEDED',
    color: '#000',
    height: 35,
    width: 35,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%'
};
exports.default = {
    container,
    left,
    right,
    image,
    font,
    userInfo,
    logoutIcon,
    containerDefaultProfile
};
